import { useEffect, useState } from "react";
import { Facebook, Mail, Link2, Check, ArrowUp } from "lucide-react";

export function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Nazaj na vrh"
      className="fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full bg-brand text-white shadow-lg hover:bg-brand/90 transition flex items-center justify-center"
    >
      <ArrowUp className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}

export function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  const enc = encodeURIComponent;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`;
  const pin = `https://pinterest.com/pin/create/button/?url=${enc(url)}&description=${enc(title)}`;
  const mail = `mailto:?subject=${enc(title)}&body=${enc(url)}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {}
  };
  const cls =
    "inline-flex items-center gap-2 rounded-xl border border-primary/25 bg-primary/5 px-4 py-2 text-xs uppercase tracking-[0.14em] text-primary hover:bg-primary/10 hover:border-primary/50 transition";
  const iconCls = "h-4 w-4 text-accent";
  return (
    <div className="mt-12 flex flex-wrap items-center gap-3">
      <span className="text-xs uppercase tracking-[0.18em] text-muted-foreground mr-1">Deli članek</span>
      <a className={cls} href={fb} target="_blank" rel="noopener noreferrer">
        <Facebook className={iconCls} aria-hidden="true" /> Facebook
      </a>
      <a className={cls} href={pin} target="_blank" rel="noopener noreferrer">
        <svg viewBox="0 0 24 24" className={iconCls} fill="currentColor" aria-hidden="true">
          <path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.1-2 .1-2.8l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.5 1.9-2.5.9 0 1.3.7 1.3 1.5 0 .9-.6 2.2-.9 3.5-.3 1 .5 1.9 1.6 1.9 1.9 0 3.2-2.4 3.2-5.3 0-2.2-1.5-3.8-4.1-3.8-3 0-4.9 2.2-4.9 4.7 0 .9.3 1.5.7 2 .2.2.2.3.1.6l-.2.8c-.1.3-.3.4-.5.3-1.4-.6-2.1-2.2-2.1-4C5.5 7.4 8 4.4 12.3 4.4c3.5 0 5.8 2.5 5.8 5.2 0 3.6-2 6.3-4.9 6.3-1 0-1.9-.5-2.2-1.2l-.6 2.4c-.2.8-.7 1.8-1.1 2.5A10 10 0 1 0 12 2z" />
        </svg>
        Pinterest
      </a>
      <a className={cls} href={mail}>
        <Mail className={iconCls} aria-hidden="true" /> E-pošta
      </a>
      <button type="button" className={cls} onClick={copy}>
        {copied ? <Check className={iconCls} aria-hidden="true" /> : <Link2 className={iconCls} aria-hidden="true" />}
        {copied ? "Povezava kopirana" : "Kopiraj povezavo"}
      </button>
    </div>
  );
}
